import React from 'react';

interface SiteBannerData {
  id?: string;
  toggleName?: string;
  heading?: string;
  subheading?: string;
  image?: string;
  backgroundImage?: string;
}


export interface IProps {
  siteBanners: SiteBannerData[];
}

export default function ToggledSiteBanner(props: IProps) {
  if (!props?.siteBanners?.length) { return null; }

  return (
    <div className="site-wrapper"/>
  );
}
